import { on } from "process";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import PropTypes from "prop-types";

import { cardBasicType } from "types";

import styles from "./ClipboardItem.module.scss";

const ClipboardItem = ({ card, legal, onAdd, onDemote, onPromote, onRemove, onShow, type }) => (
  <div className={styles.wrapper}>
    <div
      className={classNames(styles.item, {
        [styles.rec]: type === "rec",
        [styles.illegal]: !legal,
      })}
      onClick={onShow}
    >
      {card.name}
    </div>
    <div className={classNames(styles.buttons, "d-flex d-md-none")}>
      {type === "card" && card.legal_commander && (
        <span onClick={onPromote}>
          <FontAwesomeIcon className="color-gold" icon="crown" size="xl" />
        </span>
      )}
      <span onClick={() => window.open(`/${type === "rec" ? "card" : type}s/${card.url}`, "_blank")}>
        <FontAwesomeIcon className={styles.link} icon="link" size="xl" />
      </span>
      {type === "rec" ? (
        <span onClick={() => onAdd(card)}>
          <FontAwesomeIcon className={styles.addButton} icon="check" size="xl" />
        </span>
      ) : (
        <span onClick={() => onRemove(card.name)}>
          <FontAwesomeIcon className={styles.removeButton} icon="times" size="xl" />
        </span>
      )}
    </div>
    <div className={classNames(styles.buttons, "d-none d-md-flex")}>
      {type === "card" && card.legal_commander && (
        <span onClick={onPromote}>
          <FontAwesomeIcon className="color-gold" icon="crown" />
        </span>
      )}
      {onDemote && (
        <span onClick={onDemote}>
          <FontAwesomeIcon className="color-red" icon="arrow-down" size="lg" />
        </span>
      )}
      <span onClick={() => window.open(`/${type === "rec" ? "card" : type}s/${card.url}`, "_blank")}>
        <FontAwesomeIcon className={styles.link} icon="link" />
      </span>
      {type === "rec" ? (
        <span onClick={() => onAdd(card)}>
          <FontAwesomeIcon className={styles.addButton} icon="check" />
        </span>
      ) : (
        <span onClick={() => onRemove(card.name)}>
          <FontAwesomeIcon className={styles.removeButton} icon="times" size="xl" />
        </span>
      )}
    </div>
  </div>
);

ClipboardItem.propTypes = {
  card: cardBasicType,
  legal: PropTypes.bool.isRequired,
  onAdd: PropTypes.func,
  onDemote: PropTypes.func,
  onPromote: PropTypes.func,
  onRemove: PropTypes.func,
  onShow: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default ClipboardItem;
